Vue.component('category-menu-item', {
    props: {
        category: {
            required: true,
        },
        active: {
            default: false,
        },
        value: {
            default: null,
        },
        recursive: {
            default: true,
        },
    },
    //language=HTML
    template: `
        <li class="nav-item" :data-test="'cat-nav-' + category.slug + '-li'">
            <template v-if="category.children && category.children.length && recursive">
                <a class="nav-link vertical-align-middle"
                   :class="{ 'active' : isActive }"
                   :data-test="'cat-nav-' + category.slug + '-a'"
                   href="#"
                   aria-expanded="false"
                   @click.prevent="selectCategory"
                   :aria-controls="'collapseMenu' + category.id">
                    {{ category.name }} ({{ category.not_hidden_count}})
                    <button :data-test="'cat-nav-' + category.slug + '-button'" class="btn toggle-btn ml-auto" :class="{'is-open': isOpen}" @click.prevent="toggleMenu">
                        <i class="fal fa-fw fa-chevron-down"></i>
                    </button>
                    <i class="arrow"></i>
                </a>
                <div class="collapse" :id="'collapseMenu' + category.id">
                    <category-menu :categories="category.children" :sub-menu="true"></category-menu>
                </div>
            </template>
            <template v-else>
                <a class="nav-link" href="#" :data-test="'cat-nav-' + category.slug + '-a'" @click.prevent="selectCategory" :class="{active: isActive}">
                    {{ category.name }} ({{ category.not_hidden_count}})
                    <i class="arrow"></i>
                </a>
            </template>
        </li>
    `,
    data() {
        return {
            catValues: [],
            catId: null,
            isActive: false,
            isOpen: false,
        };
    },
    created() {
        this.catValues = this.getIds(this.category);
        this.catId = this.catValues.join(',');
        Bus.$on('categoryFilterSelect', this.makeActive);
        this.isActive = this.active;
    },
    beforeDestroy() {
        Bus.$off('categoryFilterSelect', this.makeActive);
    },
    methods: {
        getIds(category) {
            let childIds = _.map(_.get(category, 'children', []), (item) => {
                return item.id;
            });

            childIds.push(category.id);

            return childIds;
        },
        toggleMenu() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
                $('#collapseMenu' + this.category.id).collapse('show');
            } else {
                $('#collapseMenu' + this.category.id).collapse('hide');
            }
        },
        makeActive(category) {
            this.isActive = category.join(',') === this.catId;
        },
        selectCategory(e) {
            if (e.target.tagName !== 'BUTTON') {
                Bus.$emit('categoryFilterSelect', this.catValues);
            }
        },
    },
});
